import { useState } from "react";

export function usePrintPreview() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iframeSrc, setIframeSrc] = useState("");

  const generatePreview = (pageSize, accent) => {
    // Clones active stylesheets and visible clean layout markup
    const resumeElement = document.getElementById("cv-page");
    if (!resumeElement) return;

    const clone = resumeElement.cloneNode(true);

    // Explicit clean-up logic mapping to original native mechanics
    clone.querySelectorAll(".exp-desc").forEach((d) => {
      d.style.maxHeight = "none";
      d.style.opacity = "1";
    });
    clone
      .querySelectorAll(".expand-btn, .section-toggle, .section-drag-handle")
      .forEach((el) => el.remove());
    clone.style.padding = "0";

    const sizeMap = { A4: "A4", Letter: "letter", A3: "A3" };
    const htmlString = `
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            ${Array.from(document.styleSheets)
              .map((sheet) => {
                try {
                  return Array.from(sheet.cssRules)
                    .map((rule) => rule.cssText)
                    .join("");
                } catch {
                  return "";
                }
              })
              .join("")}
            @page { size: ${sizeMap[pageSize]} portrait; margin: 12mm; }
            :root { --accent: ${accent || "#FF4D00"}; }
            body { background: white !important; color: #1a1a1a !important; }
            
            /* Override responsive rules that hide sidebar in preview */
            @media (max-width: 900px) {
              #sidebar { display: flex !important; }
              #main-content { padding: 40px 28px !important; }
            }
            
            /* Override print rules that hide sidebar/header */
            @media print {
              #sidebar { display: flex !important; }
              #resume-header { display: block !important; }
              #main-content { background: white !important; padding: 20px !important; }
            }
            
            /* Ensure proper text colors */
            #main-content { color: #1a1a1a !important; background: white !important; }
            .exp-title, .exp-company, .skill-name, .course-name { color: #1a1a1a !important; }
          </style>
        </head>
        <body class="${document.body.className}">
          <div style="max-width: 100% !important;">${clone.outerHTML}</div>
        </body>
      </html>
    `;

    const blob = new Blob([htmlString], { type: "text/html" });
    if (iframeSrc) URL.revokeObjectURL(iframeSrc);
    setIframeSrc(URL.createObjectURL(blob));
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    if (iframeSrc) URL.revokeObjectURL(iframeSrc);
    setIframeSrc("");
  };

  return { isModalOpen, iframeSrc, generatePreview, closeModal };
}
